// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    AuthenticateUserRequestModel,
    AuthenticationAuthenticationAuthenticateUserDefaultResponse,
    AuthenticationAuthenticationChangePasswordDefaultResponse,
    AuthenticationAuthenticationGetCurrentUserDefaultResponse,
    AuthenticationAuthenticationResetPasswordDefaultResponse,
    AuthenticationAuthenticationSaveCurrentUserDefaultResponse,
    AuthenticationIsEmailRegisteredAuthenticationIsEmailRegisteredDefaultResponse,
    AuthenticationSaveCurrentUserSaveCurrentUserRequestModel,
    AuthenticationV2ClientGetAllClientsResponse,
    AuthenticationV2UserCreatePortalAdminResponse,
    ChangePasswordRequestModel,
    GatewayError,
    InitialResetPasswordRequestModel,
    IsEmailRegisteredRequestModel,
    ResetPasswordInternalRequestModel,
    ResetPasswordRequestModel,
    UserRequestModel,
    UsersInternalRequestModel,
    UsersWithSiteAccountRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeAuthenticationApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param authenticateUserRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async authenticationAuthenticateUser (authenticateUserRequestModel: AuthenticateUserRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationAuthenticationAuthenticateUserDefaultResponse>> {
        const _url_ = '/edge/authentication/AuthenticateUser';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'authenticateUserRequestModel' is not null or undefined
        if (authenticateUserRequestModel === null || authenticateUserRequestModel === undefined) {
            throw new Error('Required parameter authenticateUserRequestModel was null or undefined when calling authenticationAuthenticateUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(authenticateUserRequestModel, "AuthenticateUserRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationAuthenticationAuthenticateUserDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationAuthenticationAuthenticateUserDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param changePasswordRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async authenticationChangePassword (changePasswordRequestModel: ChangePasswordRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationAuthenticationChangePasswordDefaultResponse>> {
        const _url_ = '/edge/authentication/ChangePassword';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'changePasswordRequestModel' is not null or undefined
        if (changePasswordRequestModel === null || changePasswordRequestModel === undefined) {
            throw new Error('Required parameter changePasswordRequestModel was null or undefined when calling authenticationChangePassword.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(changePasswordRequestModel, "ChangePasswordRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationAuthenticationChangePasswordDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationAuthenticationChangePasswordDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async authenticationGetCurrentUser (body: object, xProgramId?: string): Promise<AxiosResponse<AuthenticationAuthenticationGetCurrentUserDefaultResponse>> {
        const _url_ = '/edge/authentication/GetCurrentUser';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling authenticationGetCurrentUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationAuthenticationGetCurrentUserDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationAuthenticationGetCurrentUserDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param isEmailRegisteredRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async authenticationIsEmailRegistered (isEmailRegisteredRequestModel: IsEmailRegisteredRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationIsEmailRegisteredAuthenticationIsEmailRegisteredDefaultResponse>> {
        const _url_ = '/edge/authentication/IsEmailRegistered';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'isEmailRegisteredRequestModel' is not null or undefined
        if (isEmailRegisteredRequestModel === null || isEmailRegisteredRequestModel === undefined) {
            throw new Error('Required parameter isEmailRegisteredRequestModel was null or undefined when calling authenticationIsEmailRegistered.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(isEmailRegisteredRequestModel, "IsEmailRegisteredRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationIsEmailRegisteredAuthenticationIsEmailRegisteredDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationIsEmailRegisteredAuthenticationIsEmailRegisteredDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param resetPasswordRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async authenticationResetPassword (resetPasswordRequestModel: ResetPasswordRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationAuthenticationResetPasswordDefaultResponse>> {
        const _url_ = '/edge/authentication/ResetPassword';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'resetPasswordRequestModel' is not null or undefined
        if (resetPasswordRequestModel === null || resetPasswordRequestModel === undefined) {
            throw new Error('Required parameter resetPasswordRequestModel was null or undefined when calling authenticationResetPassword.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(resetPasswordRequestModel, "ResetPasswordRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationAuthenticationResetPasswordDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationAuthenticationResetPasswordDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param authenticationSaveCurrentUserSaveCurrentUserRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async authenticationSaveCurrentUser (authenticationSaveCurrentUserSaveCurrentUserRequestModel: AuthenticationSaveCurrentUserSaveCurrentUserRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationAuthenticationSaveCurrentUserDefaultResponse>> {
        const _url_ = '/edge/authentication/SaveCurrentUser';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'authenticationSaveCurrentUserSaveCurrentUserRequestModel' is not null or undefined
        if (authenticationSaveCurrentUserSaveCurrentUserRequestModel === null || authenticationSaveCurrentUserSaveCurrentUserRequestModel === undefined) {
            throw new Error('Required parameter authenticationSaveCurrentUserSaveCurrentUserRequestModel was null or undefined when calling authenticationSaveCurrentUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(authenticationSaveCurrentUserSaveCurrentUserRequestModel, "AuthenticationSaveCurrentUserSaveCurrentUserRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationAuthenticationSaveCurrentUserDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationAuthenticationSaveCurrentUserDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async clientGetAllClients (xProgramId?: string): Promise<AxiosResponse<AuthenticationV2ClientGetAllClientsResponse>> {
        const _url_ = '/edge/authentication/v2/Client/getAllClients';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2ClientGetAllClientsResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2ClientGetAllClientsResponse");
        }
        return response;
    }
    /**
     * 
     * @param userAccountEmail 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userAccountExists (userAccountEmail: string, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/accountExists/{userAccountEmail}'
            .replace('{' + 'userAccountEmail' + '}', encodeURIComponent(String(userAccountEmail)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'userAccountEmail' is not null or undefined
        if (userAccountEmail === null || userAccountEmail === undefined) {
            throw new Error('Required parameter userAccountEmail was null or undefined when calling userAccountExists.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param usersInternalRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userCreateAnyPortalHubUser (usersInternalRequestModel: UsersInternalRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/createAnyPortalHubUser';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'usersInternalRequestModel' is not null or undefined
        if (usersInternalRequestModel === null || usersInternalRequestModel === undefined) {
            throw new Error('Required parameter usersInternalRequestModel was null or undefined when calling userCreateAnyPortalHubUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(usersInternalRequestModel, "UsersInternalRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param usersInternalRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userCreateAnyPortalStandardUser (usersInternalRequestModel: UsersInternalRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/createAnyPortalStandardUser';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'usersInternalRequestModel' is not null or undefined
        if (usersInternalRequestModel === null || usersInternalRequestModel === undefined) {
            throw new Error('Required parameter usersInternalRequestModel was null or undefined when calling userCreateAnyPortalStandardUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(usersInternalRequestModel, "UsersInternalRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param userRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userCreateHubUser (userRequestModel: UserRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/createHubUser';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'userRequestModel' is not null or undefined
        if (userRequestModel === null || userRequestModel === undefined) {
            throw new Error('Required parameter userRequestModel was null or undefined when calling userCreateHubUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(userRequestModel, "UserRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param userRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userCreatePortalAdmin (userRequestModel: UserRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/createPortalAdmin';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'userRequestModel' is not null or undefined
        if (userRequestModel === null || userRequestModel === undefined) {
            throw new Error('Required parameter userRequestModel was null or undefined when calling userCreatePortalAdmin.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(userRequestModel, "UserRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param usersInternalRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userCreatePortalAdminUser (usersInternalRequestModel: UsersInternalRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/createPortalAdminUser';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'usersInternalRequestModel' is not null or undefined
        if (usersInternalRequestModel === null || usersInternalRequestModel === undefined) {
            throw new Error('Required parameter usersInternalRequestModel was null or undefined when calling userCreatePortalAdminUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(usersInternalRequestModel, "UsersInternalRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param userRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userCreateStandardUser (userRequestModel: UserRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/createStandardUser';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'userRequestModel' is not null or undefined
        if (userRequestModel === null || userRequestModel === undefined) {
            throw new Error('Required parameter userRequestModel was null or undefined when calling userCreateStandardUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(userRequestModel, "UserRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param id 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userDeleteUser (id: string, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/deleteUser/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userDeleteUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'DELETE',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param id 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userGetUserbyAuth0Id (id: string, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/getUserbyAuth0Id/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userGetUserbyAuth0Id.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param connectionName 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userGetUsersByConnection (connectionName: string, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/getUsersByConnection/{connectionName}'
            .replace('{' + 'connectionName' + '}', encodeURIComponent(String(connectionName)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'connectionName' is not null or undefined
        if (connectionName === null || connectionName === undefined) {
            throw new Error('Required parameter connectionName was null or undefined when calling userGetUsersByConnection.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param linkedAccountId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userGetUsersByLinkedAccount (linkedAccountId: number, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/getUsersByLinkedAccount/{linkedAccountId}'
            .replace('{' + 'linkedAccountId' + '}', encodeURIComponent(String(linkedAccountId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'linkedAccountId' is not null or undefined
        if (linkedAccountId === null || linkedAccountId === undefined) {
            throw new Error('Required parameter linkedAccountId was null or undefined when calling userGetUsersByLinkedAccount.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param usersWithSiteAccountRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userGetUsersWithSiteAccount (usersWithSiteAccountRequestModel: UsersWithSiteAccountRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/getUsersWithSiteAccount';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'usersWithSiteAccountRequestModel' is not null or undefined
        if (usersWithSiteAccountRequestModel === null || usersWithSiteAccountRequestModel === undefined) {
            throw new Error('Required parameter usersWithSiteAccountRequestModel was null or undefined when calling userGetUsersWithSiteAccount.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(usersWithSiteAccountRequestModel, "UsersWithSiteAccountRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param resetPasswordInternalRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userInitiateAnyUserPasswordReset (resetPasswordInternalRequestModel: ResetPasswordInternalRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/initiateAnyUserPasswordReset';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'resetPasswordInternalRequestModel' is not null or undefined
        if (resetPasswordInternalRequestModel === null || resetPasswordInternalRequestModel === undefined) {
            throw new Error('Required parameter resetPasswordInternalRequestModel was null or undefined when calling userInitiateAnyUserPasswordReset.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(resetPasswordInternalRequestModel, "ResetPasswordInternalRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param initialResetPasswordRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userInitiatePasswordReset (initialResetPasswordRequestModel: InitialResetPasswordRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/initiatePasswordReset';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'initialResetPasswordRequestModel' is not null or undefined
        if (initialResetPasswordRequestModel === null || initialResetPasswordRequestModel === undefined) {
            throw new Error('Required parameter initialResetPasswordRequestModel was null or undefined when calling userInitiatePasswordReset.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(initialResetPasswordRequestModel, "InitialResetPasswordRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param id 
     * @param usersInternalRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userUpdateAnyUser (id: string, usersInternalRequestModel: UsersInternalRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/updateAnyUser/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userUpdateAnyUser.');
        }

        // verify required parameter 'usersInternalRequestModel' is not null or undefined
        if (usersInternalRequestModel === null || usersInternalRequestModel === undefined) {
            throw new Error('Required parameter usersInternalRequestModel was null or undefined when calling userUpdateAnyUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(usersInternalRequestModel, "UsersInternalRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     * 
     * @param id 
     * @param userRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async userUpdateUser (id: string, userRequestModel: UserRequestModel, xProgramId?: string): Promise<AxiosResponse<AuthenticationV2UserCreatePortalAdminResponse>> {
        const _url_ = '/edge/authentication/v2/User/updateUser/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userUpdateUser.');
        }

        // verify required parameter 'userRequestModel' is not null or undefined
        if (userRequestModel === null || userRequestModel === undefined) {
            throw new Error('Required parameter userRequestModel was null or undefined when calling userUpdateUser.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(userRequestModel, "UserRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<AuthenticationV2UserCreatePortalAdminResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminResponse");
        }
        return response;
    }
}
